import { MultiValuedListVariant } from './MultiValuedList.enums'

export function isMultiValuedListVariantTag(variant) {
  return variant === MultiValuedListVariant.Tag
}
